$(document).ready(function(){
    if($('.dashboard--innovations').length){
        $('.action.delete').click(function(){
            var id = $(this).attr('data-id');
            $("#modal-innovation-delete input[name='id']").attr("value", id);
        });
    }
});